// extracted by mini-css-extract-plugin
export default {"valuesContainer":"AllValues_valuesContainer__L+vsa","values":"AllValues_values__soZLP","title":"AllValues_title__tNSK4","subtitle":"AllValues_subtitle__Z-GsR"};